<script>
    import { url, layout } from '@sveltech/routify'
    import { isLoggedIn } from '../common/Guard'
    import NavItem from './NavigationItem.svelte'
    import { t, LanguageSelect } from 'totalinvoice-frontend-core'
    import { config }  from "../common/Config"

    const links = $layout.parent.children.filter(c => c.meta['showInNavigation'])

    let menuIsActive = false

    function toggleMenu() {
        menuIsActive = !menuIsActive
    }
</script>

<div class="container">
    <nav class="navbar" role="navigation" aria-label={$t('main navigation')}>
        <div class="navbar-brand">
            <a class="navbar-item navbar-logo" href={$url('/')}>
                <img src="/images/logo.svg" alt="TotalEnergies">
            </a>
            <span class="navbar-title">{$t('TotalEnergies Invoicing Platform')}</span>
            <a href={null} role="button" class="navbar-burger burger" aria-label={$t('menu')} aria-expanded="false" data-target="mainNavMenu"
                    class:is-active={menuIsActive} on:click={toggleMenu}>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div id="mainNavMenu" class="navbar-menu" class:is-active={menuIsActive}>
            <div class="navbar-start">
                {#each links as node}
                    <NavItem {node} />
                {/each}
            </div>
            <div class="navbar-end">
                <div class="navbar-item">
                    <div class="field is-grouped">
                        <!-- User -->
                        <div class="control">
                            {#if $isLoggedIn}
                                <div class="dropdown is-hoverable">
                                    <div class="dropdown-trigger">
                                        <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
                                            <span class="icon mr-0"><i class="fas fa-user"></i></span>
                                            <span class="icon is-small has-text-link">
                                                <i class="fas fa-angle-down" aria-hidden="true"></i>
                                            </span>
                                        </button>
                                    </div>
                                    <div class="dropdown-menu" id="dropdown-menu" role="menu">
                                        <div class="dropdown-content">
                                            <!-- Routify will ignore all anchors with target attribute -->
                                            <a href="{config.account_url}" target="_self" class="dropdown-item flex-align-middle">
                                                <span class="icon has-text-link mr-1"><i class="fas fa-user-circle"></i></span>
                                                <span>{$t("Account")}</span>
                                            </a>
                                            <a href={$url('./logout')} class="dropdown-item flex-align-middle">
                                                <span class="icon has-text-link mr-1"><i class="fas fa-sign-out-alt"></i></span>
                                                <span>{$t("Logout")}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            {:else}
                                <a href={$url('./login')} class="button">
                                    <span>{$t("Login")}</span>
                                    <span class="icon has-text-link"><i class="fas fa-sign-in-alt"></i></span>
                                </a>
                            {/if}
                        </div>

                        <!-- Language -->
                        <LanguageSelect />
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <div class="nav-separator" />
</div>
